import { getPlainText
// @ts-expect-error Untyped import
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import I18n from 'I18n';
import styled from 'styled-components';
import { CANDY_APPLE } from 'visitor-ui-component-library/constants/WidgetColors';
import ContentText from '../atoms/ContentText';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import EmailCaptureInput from './EmailCaptureInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorMessage = styled.span.withConfig({
  displayName: "CaptureSection__ErrorMessage"
})(["color:", ";font-size:12px;line-height:18px;text-align:left;margin-top:9px;display:flex;"], CANDY_APPLE);
export const CaptureSection = ({
  message,
  email,
  errorMessage,
  onChange,
  onKeyPress,
  onSubmit,
  submissionState
}) => {
  return /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
    children: [/*#__PURE__*/_jsx(ContentText, {
      messageId: message.id,
      "aria-label": `${I18n.text('conversations-visitor-message-history.agentSays')} ${getPlainText(message)}`,
      contentText: getPlainText(message),
      isPartialMessage: false
    }), /*#__PURE__*/_jsx(EmailCaptureInput, {
      disabled: !email,
      value: email,
      onChange: onChange,
      onKeyPress: onKeyPress,
      onSubmit: onSubmit,
      submissionState: submissionState
    }), /*#__PURE__*/_jsx(ErrorMessage, {
      "aria-live": "assertive",
      children: errorMessage
    })]
  }, "email-prompt-capture-section");
};
CaptureSection.displayName = 'CaptureSection';